
export default {
  Iso8601Short: 'Y-MM-DD'
}
